jQuery( document ).ready(function() {

  const canvas = document.getElementById("hero-lightpass");
  if( canvas ) {
    // animation
    const mobile_breakpoint = 700;
    const html = document.documentElement;
    canvas.width = document.body.clientWidth;
    const context = canvas.getContext("2d");
    let start_frame_candidates = [
      331, // cricket
      458, // swimming
      504, // hockey
      549, // climbing
      635, // water guns
    ];
    const start_frame = start_frame_candidates[Math.floor(Math.random() * start_frame_candidates.length)];
    let current_frame_count = start_frame;

    const frameCount = 40;
    let currentFrame = index => (
      `/wp-content/themes/kc22/assets/images/sequence-selection-compressed-mobile/912476772${index.toString().padStart(4, '0')}.webp`
    )
    if( canvas.width > mobile_breakpoint ) {
      currentFrame = index => (
        `/wp-content/themes/kc22/assets/images/sequence-selection-compressed/912476772${index.toString().padStart(4, '0')}.webp`
      )
    }

    const preloadImages = () => {
      document.body.classList.add('loading_images');
      for (let i = current_frame_count; i < (current_frame_count+frameCount); i++) {
        const img = new Image();
        img.src = currentFrame(i);
      }
      setTimeout( () => {
        document.body.classList.remove('loading_images');
      }, 1000);
    };

    const img = new Image()
    img.src = currentFrame(current_frame_count);
    if( canvas.width > mobile_breakpoint ) {
      canvas.height = window.innerHeight;
    } else {
      canvas.height = window.innerHeight + 50;
    }
    let img_width = canvas.width;
    let img_height = img_width*1.7778;
    if( canvas.width > mobile_breakpoint ) {
      img_height = img_width*0.5625;
    }
    let img_pos_x = 0;
    let img_pos_y = 0;
    if( img_height < canvas.height ) {
      img_height = canvas.height;
      img_width = img_height*0.5625;
      if( canvas.width > mobile_breakpoint ) {
        img_width = img_height*1.7778;
      }
      img_pos_x = -((img_width-canvas.width) / 2);
    }
    img.onload = function() {
      context.drawImage(img, img_pos_x, img_pos_y, img_width, img_height);
    }

    const updateImage = index => {
      img.src = currentFrame(index);
    }

    let lastScrollTop = 0;
    window.addEventListener('scroll', () => {
      const scrollTop = html.scrollTop;
      const maxScrollTop = html.scrollHeight - window.innerHeight;
      const scrollFraction = scrollTop / maxScrollTop;
      const frameIndex = Math.min(
        frameCount - 1,
        Math.ceil(scrollFraction * frameCount)
      );
      if( (scrollTop + window.innerHeight) > jQuery('.activities').offset().top ) {
        if( lastScrollTop < scrollTop ) {
          if( current_frame_count < ( start_frame + frameCount - 1 ) ) {
            current_frame_count++;
          }
        } else if ( lastScrollTop > scrollTop ) {
          if( current_frame_count > start_frame ) {
            current_frame_count--;
          }
        }
      }

      lastScrollTop = scrollTop;
      requestAnimationFrame(() => updateImage(current_frame_count))
    });

    preloadImages();
  }

});
